/* Mobile post "status line" burger (2026-08-17).
   On <=479px the post title line (.postInfo / .opHead) is clamped to one line:
   date+ID sit behind a ▸ meta burger and the reply links behind a "↩ N" count burger.
   This script does three things, all no-ops on desktop (where the wrappers are
   display:contents and everything flows inline via CSS):
     1. Fills each .postReplies' .replyCount with its per-post reply count and sets
        data-has so the CSS shows/hides the widget (0 replies -> hidden, no "↩ 0").
     2. Toggles .open on tap of any .postMetaSummary to reveal that panel; only one
        panel open at a time; tapping outside closes it.
     3. Poster-ID dot: on mobile the .labelId is reduced to a color sphere (CSS) and
        we fill an adjacent .idCount with "times this ID appears in THIS thread"
        (same posting.idsRelation map that powers the desktop hover count). The dot
        stays tappable to highlight all posts by that ID — processIdLabel already
        wires that onclick to the label, so we only add/refresh the counter.

   WHY DYNAMIC (event delegation + observer): posts are NOT all in the initial HTML.
   posting.addPost() injects new post cells at runtime (thread auto-refresh, latest
   feed) using the same .postMeta wrapper structure, and tooltips.js (addBackLink)
   appends one <a> per quoting post into each .panelBacklinks. So:
     - toggles use ONE document-level delegated click handler (works for any post,
       present or added later — no per-element wiring to miss);
     - the count re-runs on a debounced body MutationObserver (catches new posts and
       late backlinks) plus once at init.

   External file (loaded like navBurger.js) -> NO inline <script> -> no CSP re-hash. */
(function () {
  'use strict';

  // Count replies in one widget: N>=1 -> show ("N"), else hide (no data-has).
  function countReplies(widget) {
    var n = widget.querySelectorAll('.panelBacklinks a').length;
    var label = widget.querySelector('.replyCount');
    if (n > 0) {
      widget.setAttribute('data-has', '');
      if (label) label.textContent = String(n);
    } else {
      widget.removeAttribute('data-has');
      if (label) label.textContent = '';
    }
  }

  // Poster-ID occurrence counter (mobile). .labelId keeps its inline
  // background-color:#<idhash> (the color code); we hide its text via CSS and show
  // the count in a sibling .idCount. Reuses posting.idsRelation[id].length — the
  // exact array processIdLabel builds for the desktop hover "(N)". Thread-scoped.
  function fillIdCounts() {
    if (typeof posting === 'undefined' || !posting.idsRelation) return;
    document.querySelectorAll('.spanId').forEach(function (span) {
      var label = span.querySelector('.labelId');
      if (!label) return;
      // Prefer the clean ID captured on first fill: the label's live text can be
      // transiently rewritten by hover handlers, and a lookup miss must NOT clear
      // a known-good count (2026-08-17: "x2 then disappears" bug).
      var id = span.dataset.id || ((label.textContent || '').trim());
      if (!span.dataset.id && id) span.dataset.id = id;
      var arr = posting.idsRelation[id];
      var cnt = span.querySelector('.idCount');
      if (!cnt) {
        cnt = document.createElement('span');
        cnt.className = 'idCount';
        span.appendChild(cnt);   // after .labelId -> renders as [dot][count]
      }
      if (arr) {
        var n = arr.length;
        cnt.textContent = n > 0 ? String(n) : '';
        if (cnt.dataset.base !== undefined) cnt.dataset.base = String(n);
      }
      // arr === undefined: ID not in the relation map yet (posts still loading) —
      // leave whatever is shown; never blank a count on a lookup miss.
    });
  }

  function countAll() {
    document.querySelectorAll('.postMeta.postReplies').forEach(countReplies);
    fillIdCounts();
  }

  /* Poster-ID sphere hover effect, mobile (2026-08-17, operator ask):
     desktop shows it via posting.processIdLabel's onmouseover (text gains "(N)");
     on mobile the ID is a dot and the count sits in .idCount, so the same
     feedback is a slight alteration of THAT text: N -> xN while the finger is
     on the sphere. Tap synthesizes mouseover on mobile browsers; it reverts
     when the next tap lands elsewhere (mouseout). Delegated, so posts added
     later are covered. Desktop keeps processIdLabel's own effect untouched. */
  var idHoverMedia = window.matchMedia ? window.matchMedia('(max-width: 479px)') : null;

  function idSphereOver(e) {
    if (!idHoverMedia || !idHoverMedia.matches) return;
    var span = e.target.closest ? e.target.closest('.spanId') : null;
    if (!span) return;
    var cnt = span.querySelector('.idCount');
    if (!cnt || !cnt.textContent) return;
    // Base is the plain count (fillIdCounts keeps dataset.base in sync); only
    // alter when not already altered.
    if (cnt.textContent.charAt(0) !== '\u00d7') {
      var base = (cnt.dataset.base !== undefined) ? cnt.dataset.base : cnt.textContent;
      cnt.textContent = '\u00d7' + base;
    }
  }

  function idSphereOut(e) {
    if (!idHoverMedia || !idHoverMedia.matches) return;
    var span = e.target.closest ? e.target.closest('.spanId') : null;
    if (!span) return;
    var cnt = span.querySelector('.idCount');
    if (cnt && cnt.dataset.base !== undefined) {
      cnt.textContent = cnt.dataset.base;
    }
  }

  // Only one panel open at a time.
  function closeAll(except) {
    document.querySelectorAll('.postMeta.open').forEach(function (m) {
      if (m !== except) m.classList.remove('open');
    });
  }

  // Delegated toggle: one listener handles every burger, including posts added later.
  function onSummaryClick(e) {
    // A tap inside the poster-ID dot/counter must NOT open a panel — it belongs to
    // processIdLabel's own onclick (highlight all posts by that ID). Let it run.
    if (e.target.closest('.spanId')) return;
    var sum = e.target.closest('.postMetaSummary');
    if (!sum) return;
    e.preventDefault();
    // NOTE: no stopPropagation — other document-level handlers (e.g. navBurger's
    // outside-click close) must still see this click; our own onDocClick below already
    // no-ops for in-panel clicks via the closest('.postMeta') check.
    var meta = sum.closest('.postMeta');
    if (!meta) return;
    var willOpen = !meta.classList.contains('open');
    closeAll(meta);
    meta.classList.toggle('open', willOpen);
    sum.setAttribute('aria-expanded', String(willOpen));
  }

  // Tap outside any burger/panel closes open panels.
  function onDocClick(e) {
    if (!e.target.closest('.postMeta')) closeAll();
  }

  var recountTimer = null;
  function scheduleRecount() {
    if (recountTimer) clearTimeout(recountTimer);
    recountTimer = setTimeout(countAll, 80);
  }

  function init() {
    countAll();

    // Robustness: re-count when posts or backlinks appear/change after load.
    if (typeof MutationObserver === 'function') {
      var mo = new MutationObserver(scheduleRecount);
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  // Wire the delegated listeners once (they persist for live-added posts too).
  document.addEventListener('click', onSummaryClick);
  document.addEventListener('click', onDocClick);
  document.addEventListener('mouseover', idSphereOver);
  document.addEventListener('mouseout', idSphereOut);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
